// src/config.js
import Cookies from "js-cookie";
import { apiEndpoint } from "./urls";

const TEST_MIN_QUANTITY_COMPANY_IDS = ["375", "68309", "231", "389","66157"];
const DEVELOPER_TOOL_CREDIT_API_URL = `${apiEndpoint.developerToolBaseUri}/developer-tool/fetch_company_credits_info`;
export const EDUCATIONAL_DOCUMENTS_PRODUCT_NAME = "Educational Documents Fetch";

const normalizeCreditMappingValue = (value = "") =>
  value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

const EDUCATIONAL_DOCUMENT_TAG_PRODUCT_CODES = [
  {
    code: "SSCER",
    fetchDoctype: "SSCER",
    matches: ["10th", "ssc"],
  },
  {
    code: "HSCER",
    fetchDoctype: "HSCER",
    matches: ["12th", "hsc"],
  },
  {
    code: "DGCER",
    fetchDoctype: "DGCER",
    matches: ["degree", "diploma", "graduation"],
  },
];

const productsConfig = [
  {
    productName: "Penny Drop",
    price: 10,
    creditName: "pennydrop",
    creditAPIUrl: "https://pennydrop.meon.co.in/get_credit",
    minQuantity: 50,
  },
  {
    productName: "Pan API",
    price: 2,
    creditName: "pan",
    creditAPIUrl: "https://panapi.meon.co.in/get_credit",
    minQuantity: 250,
  },
  {
    productName: "OCR",
    price: 4,
    creditName: "ocr",
    creditAPIUrl: "https://ocr.meon.co.in/get_credit_e",
    minQuantity: 125,
  },
  {
    productName: "Location Fetch",
    price: 4,
    creditName: "ocr",
    creditAPIUrl: "https://ocr.meon.co.in/get_credit_e",
    minQuantity: 125,
  },
  // {
  //     productName: "International API Suite",
  //     price: 2,
  //     creditName: "ocr",
  //     creditAPIUrl: "https://ocr.meon.co.in/get_credit_e",
  //     minQuantity: 25,
  // },
  {
    productName: "GST Verification",
    price: 4,
    creditName: "ocr",
    creditAPIUrl: "https://ocr.meon.co.in/get_credit_e",
    minQuantity: 125,
  },
  {
    productName: "e-Doc Retrieval",
    price: 4,
    creditName: "digilocker",
    creditAPIUrl: "https://digilocker.meon.co.in/digilocker/get_credit",
    minQuantity: 125,
  },
  {
    productName: "Passport Verification",
    price: 4,
    creditName: "digilocker",
    creditAPIUrl: "https://digilocker.meon.co.in/digilocker/get_credit",
    minQuantity: 125,
  },
  {
    productName: "Aadhaar Fetch",
    price: 4,
    creditName: "digilocker",
    creditAPIUrl: DEVELOPER_TOOL_CREDIT_API_URL,
    creditTemplateId: "AADHAR",
    creditAuthRequired: true,
    minQuantity: 125,
  },
  {
    productName: "Driving License Fetch",
    price: 4,
    creditName: "digilocker",
    creditAPIUrl: "https://digilocker.meon.co.in/digilocker/get_credit",
    minQuantity: 125,
  },
  {
    productName: "Marksheet Fetch",
    price: 4,
    creditName: "digilocker",
    creditAPIUrl: "https://digilocker.meon.co.in/digilocker/get_credit",
    minQuantity: 125,
  },
  {
    productName: "Educational Documents Fetch",
    price: 4,
    creditName: "digilocker",
    creditAPIUrl: DEVELOPER_TOOL_CREDIT_API_URL,
    minQuantity: 125,
  },
  {
    productName: "Vehicle RC Fetch",
    price: 4,
    creditName: "digilocker",
    creditAPIUrl: "https://digilocker.meon.co.in/digilocker/get_credit",
    minQuantity: 125,
  },
  {
    productName: "UAN Card Fetch",
    price: 4,
    creditName: "digilocker",
    creditAPIUrl: "https://digilocker.meon.co.in/digilocker/get_credit",
    minQuantity: 125,
  },
  {
    productName: "Income Certificate Fetch",
    price: 4,
    creditName: "digilocker",
    creditAPIUrl: "https://digilocker.meon.co.in/digilocker/get_credit",
    minQuantity: 125,
  },
  {
    productName: "Apaar Card Fetch",
    price: 4,
    creditName: "digilocker",
    creditAPIUrl: "https://digilocker.meon.co.in/digilocker/get_credit",
    minQuantity: 125,
  },
  {
    productName: "Insurance Fetch",
    price: 4,
    creditName: "digilocker",
    creditAPIUrl: "https://digilocker.meon.co.in/digilocker/get_credit",
    minQuantity: 125,
  },
  {
    productName: "Meon Face Verification",
    price: 10,
    creditName: "ipv",
    creditAPIUrl: "https://face-finder.meon.co.in/backend/get_credit",
    minQuantity: 50,
  },
  {
    productName: "eSign",
    price: 20,
    creditName: "esign",
    creditAPIUrl:
      "https://esign.meon.co.in/EsignServices/GetCreditForDeveloperTool",
    minQuantity: 25,
  },
];

const getCompanyId = () => {
  if (typeof window === "undefined") {
    return null;
  }

  const sessionCompanyId = sessionStorage.getItem("company_id");
  if (sessionCompanyId) {
    return String(sessionCompanyId);
  }

  try {
    const signature = Cookies.get("c_d_token");
    if (!signature) {
      return null;
    }

    const request = new XMLHttpRequest();
    request.open("GET", "/EsignServices/getUserDetails", false);
    request.setRequestHeader("signature", signature);
    request.send();

    if (request.status < 200 || request.status >= 300) {
      return null;
    }

    if (!request.responseText || request.responseText.trim().startsWith("<")) {
      return null;
    }

    const profileData = JSON.parse(request.responseText);
    return String(profileData?.company_id ?? "");
  } catch (error) {
    return null;
  }
};

export const getProductsConfigForCompany = (companyId) => {
  const resolvedCompanyId = companyId == null ? null : String(companyId);
  const isMinQuantityOverrideCompany =
    TEST_MIN_QUANTITY_COMPANY_IDS.includes(resolvedCompanyId);

  return isMinQuantityOverrideCompany
    ? productsConfig.map((product) => ({
        ...product,
        minQuantity: 1,
      }))
    : productsConfig;
};

export const resolveEducationalCreditProductCode = ({
  productName,
  tagName,
} = {}) => {
  if (
    normalizeCreditMappingValue(productName) !==
    normalizeCreditMappingValue(EDUCATIONAL_DOCUMENTS_PRODUCT_NAME)
  ) {
    return null;
  }

  const normalizedTagName = normalizeCreditMappingValue(tagName);
  if (!normalizedTagName) {
    return null;
  }

  const matchedConfig = EDUCATIONAL_DOCUMENT_TAG_PRODUCT_CODES.find(({ matches }) =>
    matches.some((match) => normalizedTagName.includes(match))
  );

  return matchedConfig?.code ?? null;
};

export const resolveEducationalCreditFetchDoctype = ({
  productName,
  tagName,
} = {}) => {
  if (
    normalizeCreditMappingValue(productName) !==
    normalizeCreditMappingValue(EDUCATIONAL_DOCUMENTS_PRODUCT_NAME)
  ) {
    return null;
  }

  const normalizedTagName = normalizeCreditMappingValue(tagName);
  if (!normalizedTagName) {
    return null;
  }

  const matchedConfig = EDUCATIONAL_DOCUMENT_TAG_PRODUCT_CODES.find(({ matches }) =>
    matches.some((match) => normalizedTagName.includes(match))
  );

  return matchedConfig?.fetchDoctype ?? null;
};

const resolvedProductsConfig = getProductsConfigForCompany(getCompanyId());

export default resolvedProductsConfig;
